import React, { useEffect, useState } from "react";
import { FiArrowLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import AdLayout from "../components/AdLayout";
import axiosInstance from "../axiosInstance";
import { toast } from "react-toastify";

const ControlPanel = () => {
  const navigate = useNavigate();
  const [nowText, setNowText] = useState("");

  useEffect(() => {
    const formatNow = () => {
      const parts = new Intl.DateTimeFormat("en-GB", {
        timeZone: "Asia/Ho_Chi_Minh",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hourCycle: "h23",
      }).formatToParts(new Date());
      const read = (type) => parts.find((part) => part.type === type)?.value ?? "";
      return `${read("day")}-${read("month")}-${read("year")} ${read("hour")}:${read("minute")}:${read("second")}`;
    };

    setNowText(formatNow());
    const timer = window.setInterval(() => {
      setNowText(formatNow());
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);

  const setPrimaryAdmin102 = async () => {
    try {
      const response = await axiosInstance.post("/api/users/setPrimaryAdmin", { adminId: 102 });
      if (response?.data?.success) {
        toast.success(response.data.message || "Đã thiết lập admin hệ thống.");
      } else {
        toast.error(response?.data?.message || "Thiết lập admin thất bại.");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Thiết lập admin thất bại.");
    }
  };

  const clearMemberWithoutDepartment = async () => {
    try {
      const response = await axiosInstance.post("/api/users/clearMemberWithoutDivision");
      if (response?.data?.success) {
        const n = response?.data?.data;
        const msg =
          response.data.message ||
          (typeof n === "number" ? `Đã cập nhật ${n} user (isMember=false).` : "Đã cập nhật.");
        toast.success(msg);
      } else {
        toast.error(response?.data?.message || "Cập nhật thất bại.");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Cập nhật thất bại.");
    }
  };

  return (
    <div className="web-font">
      <AdLayout>
        <div className="mt-2 container p-0">
          <div className="card shadow-lg1 mb-3">
            <div className="block-header mb-2 position-relative">
              <div className="department-page-header">
                <button
                  type="button"
                  className="department-page-header__back"
                  onClick={() => navigate(-1)}
                  aria-label="Quay lại"
                  title="Quay lại"
                >
                  <FiArrowLeft size={18} />
                </button>
                <div>Bảng điều khiển</div>
              </div>
            </div>

            <div className="container form-editor" style={{ minHeight: "calc(100vh - 260px)" }}>
              <div className="row g-3">
                <div className="col-12 col-md-4">
                  <button
                    type="button"
                    className="btn btn-outline-danger btn-sm w-100"
                    onClick={setPrimaryAdmin102}
                  >
                    Thiết lập user #102 là Admin hệ thống
                  </button>
                </div>
                <div className="col-12 col-md-4">
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm w-100"
                    onClick={clearMemberWithoutDepartment}
                  >
                    Gỡ member: user isMember nhưng chưa có phòng ban/bộ phận
                  </button>
                </div>
                <div className="col-12 col-md-4">
                  <button type="button" className="btn btn-primary w-100">
                    Chức năng 03
                  </button>
                </div>
              </div>
            </div>

            <div className="border-top mt-3 px-3 py-2">
              <div className="d-flex justify-content-between align-items-center">
                <span>Tổng: 3 chức năng</span>
                <span>Time: {nowText}</span>
              </div>
            </div>
          </div>
        </div>
      </AdLayout>
    </div>
  );
};

export default ControlPanel;
